/** "Backed up 3 min ago" for the IDE header; coarse on purpose, it is reassurance, not a log. */
export function backupAge(capturedAt: string | null | undefined, now = Date.now()) {
  if (!capturedAt) return null;
  const at = Date.parse(capturedAt);
  if (!Number.isFinite(at)) return null;
  const seconds = Math.max(0, Math.round((now - at) / 1000));
  if (seconds < 60) return 'Backed up just now';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `Backed up ${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `Backed up ${hours} h ago`;
  return `Backed up ${Math.round(hours / 24)} d ago`;
}
